import { useButtonDefinitions } from 'components/eventView/overview/useButtonDefinitions';
import { EventEntityDefinition } from 'components/eventView/pages/eventData';
import { ImageBgButton } from 'elements/eventView/atomic/ImageBgButton';
import { TileButton } from 'elements/eventView/atomic/TileButton';
import { useContext } from 'react';
import { CtxEventView } from 'session/ctxEventView';
import styled, { css } from 'styled-components/macro';

interface Props {
    className?: string;
}

export const OverviewButtonsV1 = (props: Props): JSX.Element => {
    const ctxEventView = useContext(CtxEventView);
    const { eventData } = ctxEventView;
    const buttonDefinitions = useButtonDefinitions();

    function getPrime() {
        function props(id: string) {
            if (id === 'program') {
                return buttonDefinitions.programme;
            } else if (id === 'information') {
                return buttonDefinitions.information;
            }

            const otherEntityDefinition: EventEntityDefinition =
                ctxEventView.otherEntityDefinitions.find((otherEntity) => id === otherEntity.id);
            if (otherEntityDefinition) {
                return buttonDefinitions.getOtherEntity(otherEntityDefinition);
            }
        }

        return (
            <S_TileRowFull $margin={eventData.eventInfo.order.normal.length > 0}>
                {eventData.eventInfo.order.primes.map((prime) => (
                    <TileButton key={prime} {...props(prime)} />
                ))}
            </S_TileRowFull>
        );
    }

    function getNonPrimes() {
        const primeIds = eventData.eventInfo.order.primes ?? [];

        return eventData.eventInfo.order.normal
            .map((e) => {
                if (primeIds.includes(e)) {
                    return null;
                }
                if (e === 'information') {
                    return <TileButton key={e} {...buttonDefinitions.information} />;
                } else if (e === 'program') {
                    return <TileButton key={e} {...buttonDefinitions.programme} />;
                }

                const otherEntityDefinition: EventEntityDefinition =
                    ctxEventView.otherEntityDefinitions.find((otherEntity) => e === otherEntity.id);
                if (otherEntityDefinition) {
                    return (
                        <TileButton
                            key={e}
                            {...buttonDefinitions.getOtherEntity(otherEntityDefinition)}
                        />
                    );
                }
            })
            .filter(Boolean);
    }

    return (
        <S_OverviewButtonsV1 className={props.className}>
            {eventData.eventInfo.order.primes && getPrime()}
            <S_Tiles>
                {eventData.eventInfo.order.normal.length > 0 && (
                    <S_TileRowHalf $rows={Math.ceil(eventData.eventInfo.order.normal.length / 2)}>
                        {getNonPrimes()}
                    </S_TileRowHalf>
                )}
            </S_Tiles>

            {eventData.eventInfo.hasMap && <S_ImageBgButton key="map" {...buttonDefinitions.map} />}
        </S_OverviewButtonsV1>
    );
};

const S_OverviewButtonsV1 = styled.div``;

const S_Tiles = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 10px;
`;

const S_TileRowFull = styled.div<{ $margin: boolean }>`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 15px;
    ${(props) => {
        if (props.$margin) {
            return css`
                margin-bottom: 15px;
            `;
        }
    }}
`;

const S_TileRowHalf = styled.div<{ $rows: number }>`
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    flex-direction: row;
    gap: 15px;
`;

const S_ImageBgButton = styled(ImageBgButton)`
    margin-top: 15px;
`;
